import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    if (!value) return null;

    // Regex: local part only alphanumeric, dot, underscore, hyphen
    const emailRegex = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!emailRegex.test(value)) {
      return { invalidEmail: true };
    }
    
    // Angular's email validator will catch most format issues
    // Here we add stricter checks
    if (
      value.includes('..') ||            // consecutive dots
      value.startsWith('.') ||           // dot at beginning
      value.endsWith('.') ||             // dot at end
      value.indexOf('@') > 0 && value[value.indexOf('@') - 1] === '.' || // dot before @
      value.indexOf('@') > 0 && value[value.indexOf('@') + 1] === '.'    // dot after @
    ) {
      return { invalidEmail: true };
    }

    return null; // valid
  };
}